module.exports = __webpack_public_path__ + "static/mo35-98137ff9357782f97250b550bb1ca670.png";